import { Play } from "lucide-react";
import { VIDEOS, waLink } from "../../lib/site";

export const Lookbook = () => {
  return (
    <section className="relative py-20 md:py-32 bg-ink overflow-hidden">
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            "radial-gradient(60% 40% at 80% 20%, rgba(124,95,171,0.5), transparent 60%), radial-gradient(50% 40% at 20% 80%, rgba(201,169,97,0.25), transparent 60%)",
        }}
      />

      <div className="container-narrow relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div className="max-w-xl">
            <span className="overline text-gold-soft">In Motion</span>
            <h2 className="mt-3 font-serif text-4xl md:text-6xl text-cream leading-[1.05]">
              Watch our drapes
              <br />
              come <span className="italic text-gold-soft">alive</span>.
            </h2>
          </div>
          <p className="md:max-w-sm text-cream/65 leading-relaxed">
            A short film of this season's bridal & fancy edits — every fold, every
            border, every shimmer captured the way they fall in person.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {/* Tall portrait hero */}
          <a
            href={waLink("Hi! I loved your bridal lookbook — please share more.")}
            target="_blank"
            rel="noreferrer"
            data-testid="lookbook-bridal"
            className="col-span-12 md:col-span-7 relative group overflow-hidden h-[480px] md:h-[680px]"
          >
            <img
              src="/media/bridal_red.jpg"
              alt="Royal red bridal lehnga"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-10 flex items-end justify-between">
              <div>
                <span className="overline text-gold-soft">Featured · Bridal Edit</span>
                <h3 className="mt-3 font-serif text-3xl md:text-5xl text-cream max-w-md">
                  The Bride's <span className="italic text-gold-soft">first drape</span>
                </h3>
              </div>
              <span className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-full bg-cream/95 backdrop-blur flex items-center justify-center text-garnet group-hover:bg-gold group-hover:text-ink transition-colors">
                <Play size={20} fill="currentColor" />
              </span>
            </div>
          </a>

          {/* Right column: photo + text panel */}
          <div className="col-span-12 md:col-span-5 grid grid-rows-2 gap-4 md:gap-6">
            <a
              href={waLink("Hi! Show me the latest fancy / designer edits.")}
              target="_blank"
              rel="noreferrer"
              data-testid="lookbook-fancy"
              className="relative group overflow-hidden h-[280px] md:h-auto"
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                poster={VIDEOS.reelPoster}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
              >
                <source src={VIDEOS.reel} type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between">
                <div>
                  <span className="overline text-gold-soft">Designer Edit</span>
                  <h3 className="mt-2 font-serif text-2xl md:text-3xl text-cream">
                    Modern <span className="italic text-gold-soft">muses</span>
                  </h3>
                </div>
                <span className="shrink-0 w-11 h-11 rounded-full bg-cream/95 backdrop-blur flex items-center justify-center text-garnet group-hover:bg-gold group-hover:text-ink transition-colors">
                  <Play size={16} fill="currentColor" />
                </span>
              </div>
            </a>

            <div className="relative bg-garnet/15 border border-garnet/30 p-6 md:p-8 flex flex-col justify-between">
              <div>
                <span className="overline text-gold-soft">Personal styling</span>
                <p className="mt-3 font-serif text-2xl md:text-3xl text-cream leading-snug">
                  Send us your reference reels — we'll find the saree that
                  matches your vision.
                </p>
              </div>
              <a
                href={waLink("Hi! I have a reference reel I'd love to share.")}
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex items-center gap-2 text-cream text-sm tracking-[0.22em] uppercase border-b border-gold/60 hover:border-gold hover:text-gold-soft pb-1 transition-all w-fit"
                data-testid="lookbook-styling-cta"
              >
                Start a Style Chat →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lookbook;
